module.exports = {"peopleTitle":"Staggers","points":{"startFrom":0,"small":10,"big":25},"roles":["stag","bestMan"],"specialCount":10,"specialCountTimeout":5000}


//////////////////
// WEBPACK FOOTER
// ./src/config/site.json
// module id = 144
// module chunks = 0